const CURRENCY_CODE = import.meta.env?.VITE_CURRENCY_CODE || 'IDR';
const LOCALE = 'id-ID';

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat(LOCALE, {
    style: 'currency',
    currency: CURRENCY_CODE,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function getCurrencyCode(): string {
  return CURRENCY_CODE;
}
